import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";

export const getOfferStatsByArea = (maxArea?: number, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    if (!maxArea) {
        return null;
    }

    if (maxArea < 45) {
        const key = "properties_to_45m" as const;
        const statsValues = stats?.[key];

        return statsValues && statsValues.total
            ? {
                  key,
                  label: "do 45 m²",
                  ...statsValues
              }
            : null;
    }

    if (maxArea < 60) {
        const key = "properties_45m_to_60m" as const;
        const statsValues = stats?.[key];

        return statsValues && statsValues.total
            ? {
                  key,
                  label: "od 45 do 60 m²",
                  ...statsValues
              }
            : null;
    }

    const key = "properties_over_60m" as const;
    const statsValues = stats?.[key];

    return statsValues && statsValues.total
        ? {
              key,
              label: "powyżej 60 m²",
              ...statsValues
          }
        : null;
};
import {IOfferDetailStats} from "../../../offer/types/IOfferDetail";

export const getOfferStatsByArea = (maxArea?: number, stats?: IOfferDetailStats["building_parameters_stats"]) => {
    if (!maxArea) {
        return null;
    }

    if (maxArea < 45) {
        const key = "properties_to_45m" as const;
        const statsValues = stats?.[key];

        return statsValues && statsValues.total
            ? {
                  key,
                  label: "do 45 m²",
                  ...statsValues
              }
            : null;
    }

    if (maxArea < 60) {
        const key = "properties_45m_to_60m" as const;
        const statsValues = stats?.[key];

        return statsValues && statsValues.total
            ? {
                  key,
                  label: "od 45 do 60 m²",
                  ...statsValues
              }
            : null;
    }

    const key = "properties_over_60m" as const;
    const statsValues = stats?.[key];

    return statsValues && statsValues.total
        ? {
              key,
              label: "powyżej 60 m²",
              ...statsValues
          }
        : null;
};
